import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Crown, Loader2, LockKeyhole, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';

const formatApiErrorDetail = (detail) => {
  if (!detail) return 'Unable to sign in. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || JSON.stringify(item)).join(' ');
  }
  return detail.msg || String(detail);
};

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(location.state?.from || '/admin', { replace: true });
    } catch (requestError) {
      setError(formatApiErrorDetail(requestError.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page" data-testid="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <img src="/king-siege-logo-new.jpeg" alt="King Siege LLC" />
        </div>
        <p className="eyebrow">Private owner access</p>
        <h1>Admin Login</h1>
        <p className="admin-login-copy">Secure booking, balance, and referral tracking for Siege's Playcation.</p>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div>
            <Label htmlFor="admin-email">Email</Label>
            <div className="admin-input-wrap">
              <Mail className="h-4 w-4" />
              <Input
                id="admin-email"
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                required
              />
            </div>
          </div>
          <div>
            <Label htmlFor="admin-password">Password</Label>
            <div className="admin-input-wrap">
              <LockKeyhole className="h-4 w-4" />
              <Input
                id="admin-password"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
          </div>

          {error && <div className="admin-login-error" data-testid="admin-login-error">{error}</div>}

          <Button className="gold-cta admin-login-submit" data-testid="admin-login-button" disabled={loading}>
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Crown className="h-5 w-5" />}
            {loading ? 'Signing in...' : 'Sign in'}
          </Button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
